// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"62b24bfa","485":"eff76063","513":"9952b9b4"}[chunkId] + ".chunk.js";
};